import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { callPostApi } from "../../../api/ApiCaller";
import * as ApiConst from "../../../api/ApiConst"
import { NO_ERROR } from "../../../api/constants";
import * as clevertapEvents from '../../../clevertapEvents'
import * as staticConstants from '../../../translations/en/en'
import { InformationAlert } from "../../common";

const AddBalance = (props) => {
    const [addBalanceAndPromoCode, setAddBalanceAndPromoCode] = useState({ addBalance: 0, promoCode: "" });
    const navigate = useNavigate()
    const location = useLocation()

    const addAmountBy = (addValue) => {
        setAddBalanceAndPromoCode(prev => ({ ...prev, addBalance: addValue }))
    }
    const handleAddBalanceAndPromoChange = (e) => {
        const { name, value } = e.target
        if (name === "addBalance") {
            setAddBalanceAndPromoCode(prev => ({ ...prev, [name]: parseInt(value) }))
        } else {
            setAddBalanceAndPromoCode(prev => ({ ...prev, [name]: value }))
        }
    }

    const handleApplyCoupon = () => {
        if (!addBalanceAndPromoCode.promoCode) {
            toast(staticConstants.PLEASE_ENTER_PROMO_CODE)
            return
        }
        const rUrl = ApiConst.Post_Redeem_Voucher
        // order reference id 
        const rObj = { voucherCode: addBalanceAndPromoCode.promoCode }
        const toastId = toast.loading(staticConstants.VERIFYING_COUPON)
        callPostApi(rUrl, rObj, {}, response => {
            if (response.errorCode === NO_ERROR) {
                clevertapEvents.voucherConsumeEvent(addBalanceAndPromoCode.promoCode)
                toast.dismiss(toastId)
                InformationAlert({ message: response.message })
                setAddBalanceAndPromoCode({ ...addBalanceAndPromoCode, promoCode: "" })
                props.getRewardPointAndWalletBalance()
            } else {
                toast.dismiss(toastId)
                InformationAlert({ message: response.message })
            }
        })
    }

    const handleAddWalletBalanceSecurely = () => {
        if (!addBalanceAndPromoCode.addBalance) {
            toast(staticConstants.PLEASE_SELECT_AMOUNT_TO_BE_ADDED)
            return
        }
        const action = "Add_Wallet_Balance"
        navigate("/payment-methods", { state: { payableUsingGateWay: addBalanceAndPromoCode.addBalance, payableUsingWallet: 0, previousPath: location.pathname, action } })
    }

    return (
        <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="tabs-holder horizontal h-100">
                    <div className="tab-content bg-white h-100 ">
                        <div id="home" className="tab-pane fade in active show">
                            <div className="menu-itam-holder">
                                <div className="d-flex align-items-center justify-content-start gap-2 mb-4">
                                    <div>
                                        <img
                                            src="../img/wallet.png"
                                            alt="wallet"
                                            width="25px"
                                        />
                                    </div>
                                    <div className="item-title">
                                        <h5 className="text-color mb-0 font-weight-800 font-size-16">
                                            {staticConstants.ADD_TO_YOUR_WALLET}
                                        </h5>
                                    </div>
                                </div>
                                <div className="bg-gray-1 border-radius-5 p-2 border-dark mb-4">
                                    <input
                                        type="number"
                                        style={{ background: "transparent" }}
                                        placeholder="Enter Amount"
                                        className="mb-0 font-size-14 font-weight-600 text-gray w-100"
                                        value={addBalanceAndPromoCode.addBalance || ""}
                                        onChange={handleAddBalanceAndPromoChange}
                                        name="addBalance"
                                    />
                                </div>
                                <div className="row mx-auto pb-4 border-bottom">
                                    {[2000, 5000, 10000].map(
                                        (currentAmount, i) => (
                                            <div
                                                key={i}
                                                onClick={() => addAmountBy(currentAmount)}
                                                style={{ cursor: "pointer" }}
                                                className="col-4 width-100"
                                            >
                                                <div className="wallet-box border-radius-5 d-flex justify-content-center align-items-center">
                                                    <h5 className="font-weight-800 font-size-16 text-center text-gray mb-0">
                                                        +₹{currentAmount}
                                                    </h5>
                                                </div>
                                            </div>
                                        )
                                    )}
                                    <div className=" col-md-12 d-flex justify-content-center align-items-center mt-4">
                                        <span
                                            onClick={handleAddWalletBalanceSecurely}
                                            className="custom-btn btn bg-yellow text-black w-100"
                                        >
                                            {staticConstants.ADD_SECURELY}
                                        </span>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-start gap-2 my-4">
                                    <div>
                                        <img
                                            src="../img/wallet.png"
                                            alt="wallet"
                                            width="25px"
                                        />
                                    </div>
                                    <div className="item-title">
                                        <h5 className="text-color mb-0 font-weight-800 font-size-16">
                                            {staticConstants.HAVE_A_PROMO_CODE}
                                        </h5>
                                    </div>
                                </div>
                                <div className="bg-gray-1 border-radius-5 p-2 border-dark mb-4 ">
                                    <input
                                        type="text"
                                        style={{ background: "transparent" }}
                                        placeholder="Enter Code"
                                        className="mb-0 font-size-14 font-weight-600 text-gray w-100"
                                        value={addBalanceAndPromoCode.promoCode}
                                        onChange={handleAddBalanceAndPromoChange}
                                        name="promoCode"
                                    />
                                </div>
                                <div className="  d-flex justify-content-center align-items-center mb-4">
                                    <span
                                        onClick={handleApplyCoupon}
                                        className="custom-btn btn bg-yellow text-black w-100"
                                    >
                                        {staticConstants.APPLY_CODE}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddBalance;
